const componentContainer = "flex items-center gap-1 self-stretch w-full";

const PropertyPalThinking = ({ color = "#D0E4FB", strokeWidth = 2 }) => {
  const viewBox = "0 0 40 12";

  return (
    <div className={componentContainer}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewBox}
        width="40"
        height="12"
        color={color}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="6" cy="6" r="5" fill="currentColor" opacity=".6">
          <animate
            id="SVG7x14Dcom"
            fill="freeze"
            attributeName="opacity"
            begin="0;SVGqSjG0dUp.end-0.25s"
            dur="0.75s"
            values="1;.2"
          />
        </circle>
        <circle cx="20" cy="6" r="5" fill="currentColor" opacity=".8">
          <animate fill="freeze" attributeName="opacity" begin="SVG7x14Dcom.begin+0.15s" dur="0.75s" values="1;.2" />
        </circle>
        <circle cx="34" cy="6" r="5" fill="currentColor">
          <animate
            id="SVGqSjG0dUp"
            fill="freeze"
            attributeName="opacity"
            begin="SVG7x14Dcom.begin+0.3s"
            dur="0.75s"
            values="1;.2"
          />
        </circle>
      </svg>
    </div>
  );
};

export default PropertyPalThinking;
